import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {IonSearchbar, ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {ProductRecommendationService} from "../../providers/product-recommendation.service";
import {User} from "../../models/user.model";

@Component({
  selector: 'app-user-finder',
  templateUrl: './user-finder.component.html',
  styleUrls: ['./user-finder.component.scss'],
})
export class UserFinderComponent implements OnInit, OnDestroy {

  @Input()
  title: string;

  @Input()
  dataToFind: string;

  chosenItem: User | null = null;
  productRecommendationSub: Subscription;
  isBusySub: Subscription;


  items: User[];
  @ViewChild('search') search: IonSearchbar;


  private isBusy: boolean;
  isLoading: boolean = false;
  @Input()
  vClientUUID: string;

  constructor(private modalController: ModalController,
              private productRecommendationService: ProductRecommendationService,
              private commonUtils: CommonUtils,
              private appStateService: AppStateService) {
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }


  ionViewDidEnter() {
    if (this.search) {
      this.search.setFocus();
    }
  }

  prepareFoundItems() {
    if (this.dataToFind.length >= 3) {
      console.log('Name to find', this.dataToFind);
      this.appStateService.updateIsBusySubject(true);
      this.isLoading = true;
      this.productRecommendationSub = this.productRecommendationService.searchForUserByPhraseToRecommendProduct(this.dataToFind, this.vClientUUID).subscribe(users => {
        if (users) {
          this.items = users;
          this.items.forEach(item => {
            console.log(item)
          })
        }
        this.isLoading = false;
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.isLoading = false;
        switch (error.message) {
          case 'USER_NOT_FOUND':
            this.commonUtils.presentAlertToast('Nie znaleziono użykownika');
            this.appStateService.updateIsBusySubject(false);
            break;
          default:
            this.commonUtils.presentAlertToast('Wystąpił błąd');
            this.appStateService.updateIsBusySubject(false);
        }
      });
    }

  }

  onItemChosen(user: User) {
    this.chosenItem = user;
    this.modalController.dismiss(this.chosenItem, 'confirm');
  }

  ngOnDestroy() {
    if (this.productRecommendationSub) {
      this.productRecommendationSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }

  }

  getItemName(user: User) {
    return `${user.firstName} ${user.lastName} / ${user.mobilePhone} / ${user.mobilePhone}`;

  }
}
